module.exports = __webpack_public_path__ + "vsts-logo.svg";


//////////////////
// WEBPACK FOOTER
// ./images/integrations/vsts-logo.svg
// module id = 1272
// module chunks = 74